const Links = {
  twitterLink: "https://twitter.com",
  facebookLink: "https://facebook.com",
  telegramLink: "https://telegram.org"
}

export default Links